"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable_1 = require("../../Collections/HashMap/Hashtable");
var Vector_1 = require("../../Collections/Vector");
var BufferedReader_1 = require("../../Helpers/BufferedReader");
var StringBuilder_1 = require("../../Utils/StringBuilder");
var TextUtils_1 = require("../../Utils/TextUtils");
var Utils_1 = require("../../Utils/Utils");
var CssParseException_1 = require("./CssParseException");
var XoneCssRule_1 = require("./XoneCssRule");
var ParseStates;
(function (ParseStates) {
    ParseStates[ParseStates["ExpectingSelector"] = 0] = "ExpectingSelector";
    ParseStates[ParseStates["ExpectingCommentOpenComplete"] = 1] = "ExpectingCommentOpenComplete";
    ParseStates[ParseStates["GettingComment"] = 2] = "GettingComment";
    ParseStates[ParseStates["ExpectingCommentClose"] = 3] = "ExpectingCommentClose";
    ParseStates[ParseStates["GettingSelector"] = 4] = "GettingSelector";
    ParseStates[ParseStates["ExpectingOpenBrace"] = 5] = "ExpectingOpenBrace";
    ParseStates[ParseStates["ExpectingRuleKey"] = 6] = "ExpectingRuleKey";
    ParseStates[ParseStates["GettingRuleKey"] = 7] = "GettingRuleKey";
    ParseStates[ParseStates["ExpectingRuleValue"] = 8] = "ExpectingRuleValue";
    ParseStates[ParseStates["GettingRuleValue"] = 9] = "GettingRuleValue";
})(ParseStates || (ParseStates = {}));
;
var XoneCssParser = /** @class */ (function () {
    /**
     * Constructor de la clase para crearnos las cositas que nos hacen falta.
     */
    function XoneCssParser(sName, is, sEncoding, bStrictMode) {
        this.m_strName = "";
        this.m_bStrictMode = false;
        this.m_strName = sName;
        this.m_bStrictMode = bStrictMode;
        this.m_bundleRules = new Hashtable_1.default();
        this.parse(new BufferedReader_1.default(is), sEncoding);
    }
    XoneCssParser.prototype.getName = function () {
        return this.m_strName;
    };
    XoneCssParser.prototype.isStrictMode = function () {
        return this.m_bStrictMode;
    };
    /**
     * F11092607: Tener en cuenta los separadores entre clave y valor en los CSS.
     * Función para moverse al siguiente token ignorando separadores.
     *
     * @param line
     * @param br
     * @param startPos
     * @return
     * @throws IOException
     */
    XoneCssParser.prototype.moveToNextToken = function (line, br, startPos) {
        var k = startPos;
        var ch = "";
        while (null != line) {
            var n = line.length;
            while (k < n) {
                ch = line.charAt(k);
                switch (ch) {
                    case '\t':
                    case ' ':
                        k++;
                        break;
                    default:
                        // Error
                        return ch;
                }
            }
            line = br.readLine();
            k = 0;
            ch = "";
        }
        return ch;
    };
    /**
     * Carga el fichero que se le pasa como parámetro y parsea su contenido.
     * 27/07/2018 Mejoras para lanzar errores de parseo descriptivos
     *
     * @param is        Stream origen de los datos, que en teoría deberían proceder de un fichero
     *                  CSS o de un nodo XML. Al terminar o lanzar una excepción será cerrado.
     * @param sEncoding El charset usado para leer el fichero. Para evitar problemas, debería ser
     *                  UTF-8 como indica el estándar
     * @throws IOException
     */
    // private parse(is:any, sEncoding:string):void{
    //     // Juan Carlos, respetar el atributo encoding en los CSS.
    //     if (TextUtils.isEmpty(sEncoding)) {
    //         sEncoding = "ISO8859_1";
    //     }
    //     InputStreamReader isr = null;
    //     BufferedReader br = null;
    //     try {
    //         isr = new InputStreamReader(is, sEncoding);
    //         br = new BufferedReader(isr);
    //         parse(br);
    //     } finally {
    //         Utils.closeSafely(br, isr, is);
    //     }
    // }
    XoneCssParser.prototype.parse = function (br, sEncoding) {
        var strLine = "";
        var parseState = ParseStates.ExpectingSelector;
        var states = new Vector_1.default();
        var strSelector = Utils_1.Utils.EMPTY_STRING;
        var strRuleKey = Utils_1.Utils.EMPTY_STRING;
        var strRuleValue = Utils_1.Utils.EMPTY_STRING;
        var cssRule = null;
        var nLine = 0;
        while (null != (strLine = br.readLine())) {
            var nPosition = 0;
            var nLineLength = strLine.length;
            nLine++;
            while (nPosition < nLineLength) {
                var sCurrentCharacter = strLine.charAt(nPosition);
                switch (parseState) {
                    case ParseStates.ExpectingSelector:
                        // No hay selector iniciado
                        if (XoneCssParser.m_strValidChars.indexOf(sCurrentCharacter) != -1) {
                            // Caracter válido para iniciar selector
                            parseState = ParseStates.GettingSelector;
                            break;
                        }
                        // Si no hay selector iniciado podría ser un espacio
                        switch (sCurrentCharacter) {
                            case '\t':
                            case ' ':
                                nPosition++;
                                break;
                            case '/':
                                nPosition++;
                                states.push(parseState);
                                parseState = ParseStates.ExpectingCommentOpenComplete;
                                break;
                            default:
                                // Error
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Expected selector, got \"" + sCurrentCharacter + "\"");
                        }
                        break;
                    case ParseStates.ExpectingCommentOpenComplete:
                        // Solo esperamos asterisco
                        if (sCurrentCharacter != '*') {
                            throw new CssParseException_1.default(this.getName(), nLine, strLine, "Expected open comment asterisk, got \"" + sCurrentCharacter + "\"");
                        }
                        nPosition++;
                        parseState = ParseStates.GettingComment;
                        break;
                    case ParseStates.GettingComment:
                        // Lo que viene es comentario
                        if (sCurrentCharacter == '*') {
                            parseState = ParseStates.ExpectingCommentClose;
                        }
                        // Nos cagamos en el comentario
                        nPosition++;
                        break;
                    case ParseStates.ExpectingCommentClose:
                        // Ver si termina el comentario
                        if (sCurrentCharacter == '/') {
                            // Comentario completo
                            parseState = states.pop();
                            nPosition++;
                        }
                        else {
                            // De lo contrario el comentario no ha terminado
                            parseState = ParseStates.GettingComment;
                        }
                        break;
                    case ParseStates.GettingSelector:
                        // Selector iniciado
                        if (XoneCssParser.m_strValidChars.indexOf(sCurrentCharacter) != -1) {
                            // Sumamos este
                            strSelector += sCurrentCharacter;
                            nPosition++;
                            break;
                        }
                        switch (sCurrentCharacter) {
                            case '\t':
                            case ' ':
                                // Selector terminado
                                nPosition++;
                                parseState = ParseStates.ExpectingOpenBrace;
                                break;
                            case '{':
                                // Selector terminado, regla iniciada
                                nPosition++;
                                parseState = ParseStates.ExpectingRuleKey;
                                break;
                            case '/':
                                // Podría ser un comentario
                                parseState = ParseStates.ExpectingOpenBrace;
                                states.push(parseState);
                                parseState = ParseStates.ExpectingCommentOpenComplete;
                                nPosition++;
                                break;
                            case ':':
                                // A12042502: Los selectores de CSS pueden estar tipificados.
                                // Este caracter es válido en los selectores...
                                strSelector += sCurrentCharacter;
                                nPosition++;
                                break;
                            default:
                                // Error
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Expected selector, got \"" + sCurrentCharacter + "\"");
                        }
                        break;
                    case ParseStates.ExpectingOpenBrace:
                        // Esperando una llave
                        switch (sCurrentCharacter) {
                            case ' ':
                            case '\t':
                                nPosition++;
                                break;
                            case '{':
                                // Regla iniciada
                                nPosition++;
                                parseState = ParseStates.ExpectingRuleKey;
                                break;
                            case '/':
                                // Podría ser un comentario
                                parseState = ParseStates.ExpectingOpenBrace;
                                states.push(parseState);
                                parseState = ParseStates.ExpectingCommentOpenComplete;
                                nPosition++;
                                break;
                            default:
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Expected open brace character, got \"" + sCurrentCharacter + "\"");
                        }
                        break;
                    case ParseStates.ExpectingRuleKey:
                        // Estamos esperando un inicio de clave de regla
                        if (XoneCssParser.m_strValidChars.indexOf(sCurrentCharacter) != -1) {
                            // Inicio de clave válido
                            strRuleKey += sCurrentCharacter;
                            nPosition++;
                            parseState = ParseStates.GettingRuleKey;
                            break;
                        }
                        switch (sCurrentCharacter) {
                            case '}':
                                // Regla terminada?
                                if (cssRule != null) {
                                    this.m_bundleRules.put(strSelector, cssRule);
                                    cssRule = null;
                                }
                                strSelector = strRuleKey = strRuleValue = "";
                                nPosition++;
                                // Estado esperando nueva definición
                                parseState = ParseStates.ExpectingSelector;
                                break;
                            case ' ':
                            case '\t':
                                nPosition++;
                                break;
                            case '/':
                                states.push(parseState);
                                parseState = ParseStates.ExpectingCommentOpenComplete;
                                nPosition++;
                                break;
                            default:
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Expected new rule key character, got \"" + sCurrentCharacter + "\"");
                        }
                        break;
                    case ParseStates.GettingRuleKey:
                        // Obteniendo clave de regla
                        if (XoneCssParser.m_strValidChars.indexOf(sCurrentCharacter) != -1 && sCurrentCharacter != '.') {
                            // Contamos
                            strRuleKey += sCurrentCharacter;
                            nPosition++;
                            break;
                        }
                        // F11092607: Tener en cuenta los separadores entre clave y valor en los CSS.
                        // Moverse al siguiente token ignorando separadores.
                        sCurrentCharacter = this.moveToNextToken(strLine, br, nPosition);
                        if (sCurrentCharacter != ':') {
                            throw new CssParseException_1.default(this.getName(), nLine, strLine, "Unexpected token while getting rule key, got\"" + sCurrentCharacter + "\"");
                        }
                        // Terminada la clave
                        parseState = ParseStates.ExpectingRuleValue;
                        nPosition++;
                        break;
                    case ParseStates.ExpectingRuleValue:
                        // Aquí tiene que empezar el valor ya
                        switch (sCurrentCharacter) {
                            case ';':
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Unexpected blank value");
                            case '}':
                                // 11/04/2019 Mostrar errores de CSS rotos
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, "Unexpected end bracket value");
                        }
                        // De lo contrario empieza el valor
                        strRuleValue += sCurrentCharacter;
                        nPosition++;
                        parseState = ParseStates.GettingRuleValue;
                        break;
                    case ParseStates.GettingRuleValue:
                        // Cualquier cosa es un valor
                        if (sCurrentCharacter == ';') {
                            // Valor completo
                            if (cssRule == null) {
                                cssRule = new XoneCssRule_1.default(strSelector);
                            }
                            cssRule.addRule(strRuleKey, strRuleValue);
                            nPosition++;
                            parseState = ParseStates.ExpectingRuleKey;
                            strRuleKey = strRuleValue = "";
                            break;
                        }
                        else if (sCurrentCharacter == '\\') {
                            /*
                             * Carácter de escape. Si es algo que reconozcamos, como los dos puntos,
                             * sumamos el valor y nos saltamos 2 posiciones, no 1.
                             */
                            var sNextCharacter = strLine.charAt(nPosition + 1);
                            if (sNextCharacter == ':') {
                                strRuleValue += sNextCharacter;
                                nPosition = nPosition + 2;
                                break;
                            }
                            strRuleValue += sCurrentCharacter;
                            nPosition++;
                            break;
                        }
                        else if (sCurrentCharacter == ':') {
                            if (this.m_bStrictMode) {
                                var sbMessage = new StringBuilder_1.default("Missing semicolon value terminator.");
                                if (!TextUtils_1.default.isEmpty(strSelector)) {
                                    sbMessage.append("\nIn selector: ");
                                    sbMessage.append(strSelector);
                                }
                                if (!TextUtils_1.default.isEmpty(strRuleKey)) {
                                    sbMessage.append("\nIn CSS rule: ");
                                    sbMessage.append(strRuleKey);
                                }
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, sbMessage.toString());
                            }
                        }
                        else if (sCurrentCharacter == '}') {
                            // 11/04/2019 Mostrar errores de CSS rotos
                            if (this.m_bStrictMode) {
                                var sbMessage = new StringBuilder_1.default("Unexpected end bracket found while getting rule value. Missing semicolon value terminator?");
                                if (!TextUtils_1.default.isEmpty(strSelector)) {
                                    sbMessage.append("\nIn selector: ");
                                    sbMessage.append(strSelector);
                                }
                                if (!TextUtils_1.default.isEmpty(strRuleKey)) {
                                    sbMessage.append("\nIn CSS rule: ");
                                    sbMessage.append(strRuleKey);
                                }
                                throw new CssParseException_1.default(this.getName(), nLine, strLine, sbMessage.toString());
                            }
                        }
                        // Cualquier otra cosa, sumamos al valor
                        strRuleValue += sCurrentCharacter;
                        nPosition++;
                        break;
                    default:
                        throw new CssParseException_1.default(this.getName(), nLine, strLine, "Unexpected parse state: " + parseState);
                }
            }
        }
    };
    /**
     * Dado el nombre de un selector devuelve la regla CSS que responde a dicho selector o NULL si
     * no existe.
     *
     * @param strSelector
     * @return
     */
    XoneCssParser.prototype.getRuleBySelector = function (strSelector) {
        return this.m_bundleRules.get(strSelector);
    };
    XoneCssParser.prototype.addRule = function (strSelector, cssRule) {
        this.m_bundleRules.put(strSelector, cssRule);
    };
    XoneCssParser.PARCELABLE_VERSION = 2;
    XoneCssParser.BUNDLE_KEY_DATA = "data";
    XoneCssParser.BUNDLE_KEY_CRC = "crc";
    XoneCssParser.m_strValidChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.-_";
    return XoneCssParser;
}());
exports.default = XoneCssParser;

//# sourceMappingURL=XoneCssParser.js.map
